import penguin from "../data/assets/penguin.png"
import profilepic from "../data/assets/profile.jpg"
import resume from "../data/assets/resume.pdf"
import backgroundimage from "../data/assets/background.png"

// PORTFOLIO
// newsletter
import newsletter from "../data/assets/portfolio/newsletter/newsletter.png"

// tks
import tks from "../data/assets/portfolio/tks/tks.png"
import citychallenge from "../data/assets/portfolio/tks/citychallenge.png"
import fourPrint from "../data/assets/portfolio/tks/4dprint.png"
import planit from "../data/assets/portfolio/tks/planit.png"
import longevitypitch from "../data/assets/portfolio/tks/longevitypitch.png"
import loremsemper from "../data/assets/portfolio/tks/loremsemper/loremsemper.png"
import loremsemper_onepager from "../data/assets/portfolio/tks/loremsemper/hapticai_onepager.png"
import loremsemper_video from "../data/assets/portfolio/tks/loremsemper/hapticai_video.png"
import psiquantum from "../data/assets/portfolio/tks/psiquantum.png"
import stemcells from "../data/assets/portfolio/tks/stemcells.png"
import unchallenge from "../data/assets/portfolio/tks/unchallenge.png"
import nanotech from "../data/assets/portfolio/tks/nanotech.png"
import ribosoma from "../data/assets/portfolio/tks/ribosoma.png"

// articles
import mediumarticles from "../data/assets/portfolio/articles/medium_articles.png"
import growtharticle from "../data/assets/portfolio/articles/growth_article.jpeg"
import aiarticle from "../data/assets/portfolio/articles/ai_article.jpeg"
import aireflectionarticle from "../data/assets/portfolio/articles/ai_reflection_article.png"

// work
import codeca from "../data/assets/portfolio/c3d_web.png"

import bcrenal from "../data/assets/portfolio/bcrenal/bcrenal.mp4"
import patientapp from "../data/assets/portfolio/bcrenal/patientapp.png"

import vrrc from "../data/assets/portfolio/vrrc/vrrc.png"
import csa_rcm from "../data/assets/portfolio/vrrc/CSA_RCM_Nov2024.jpeg"
import volc_detection from "../data/assets/portfolio/vrrc/CSC495/volc_detection.png"
import final_presentation from "../data/assets/portfolio/vrrc/CSC495/CSC495_Final_Presentation.pdf"
import final_report from "../data/assets/portfolio/vrrc/CSC495/CSC495_Final_Report.pdf"

// coursework
import csc110 from "../data/assets/portfolio/CSC110/CSC110_Project.pdf"
import lineplot from "../data/assets/portfolio/CSC110/line_plot_default.png"

import csc207 from "../data/assets/portfolio/CSC207/CSC207_Presentation.pdf"
import uoftinder from "../data/assets/portfolio/CSC207/uoftinder.png"

import csc258 from "../data/assets/portfolio/CSC258/CSC258_FinalProject.pdf"
import breakout from "../data/assets/portfolio/CSC258/breakout.png"

import csc309 from "../data/assets/portfolio/CSC309/OneOnOne_API_Documentation.pdf"
import oneOnOne from "../data/assets/portfolio/CSC309/oneOnOne.png"

import csc311 from "../data/assets/portfolio/CSC311/CSC311_Final_Report.pdf"
import graph from "../data/assets/portfolio/CSC311/graph.png"

import csc396 from "../data/assets/portfolio/CSC396/CSC396_Final_Presentation.pdf"
import housinghippos from "../data/assets/portfolio/CSC396/housinghippos.png"

import csc494 from "../data/assets/portfolio/CSC494/CSC494_Final_Report.pdf"
import campuseats from "../data/assets/portfolio/CSC494/campusEats.png"

import horologic from "../data/assets/portfolio/CSC491/horologic.png"
import sentinel from "../data/assets/portfolio/CSC491/sentinel.png"

// projects
import craftingsjoy from "../data/assets/portfolio/craftingsjoy/craftingsjoy.png"
import craftingsjoyBOTA from "../data/assets/portfolio/craftingsjoy/craftingsjoyBOTA.jpg"
import craftingsjoyInsta from "../data/assets/portfolio/craftingsjoy/craftingsjoyInstagram.png"

import upcyc from "../data/assets/portfolio/upcyc/upcyc.png"
import upcycBOTA from "../data/assets/portfolio/upcyc/upcycBOTA.jpg"
import upcycNCOY from "../data/assets/portfolio/upcyc/upcycNationalCOY.jpg"
import upcycPrototype from "../data/assets/portfolio/upcyc/upcycPrototype.png"
import upcycWebsite from "../data/assets/portfolio/upcyc/upcycWebsite.png"
import upcycInsta from "../data/assets/portfolio/upcyc/upcycInstagram.png"

import brainer from "../data/assets/portfolio/brainer/brainer.png"
import brainerPromo from "../data/assets/portfolio/brainer/brainerPromo.jpg"
import brainerTeam from "../data/assets/portfolio/brainer/brainerTeam.jpg"
import brainerPrototype from "../data/assets/portfolio/brainer/brainerPrototype.png"
import brainerWebsite from "../data/assets/portfolio/brainer/brainerWebsite.png"
import brainerInsta from "../data/assets/portfolio/brainer/brainerInstagram.png"

import battle from "../data/assets/portfolio/battle.png"
import uniplanit from "../data/assets/portfolio/uniplanit.png"
import petudier from "../data/assets/portfolio/petudier.png"
import uclit from "../data/assets/portfolio/uclit.png"
import asocial from "../data/assets/portfolio/asocial.png"


const srcURLs = {
    penguin,
    profilepic,
    resume,
    backgroundimage,
    newsletter: {
      newsletter,
    },
    // tks
    tks: {
      tks,
      citychallenge,
      fourPrint,
      planit,
      longevitypitch,
      loremsemper: {
        loremsemper,
        loremsemper_onepager,
        loremsemper_video
      },
      psiquantum,
      stemcells,
      unchallenge,
      nanotech,
      ribosoma
    },
    articles: {
      mediumarticles,
      growtharticle,
      aiarticle,
      aireflectionarticle
    },
    // work
    codeca,
    bcrenal: {
      bcrenal,
      patientapp
    },
    vrrc: {
      vrrc,
      csa_rcm,
      csc495: {
        volc_detection,
        final_presentation,
        final_report
      }
    },
    csc110: {
      csc110,
      lineplot
    },
    csc207: {
      csc207,
      uoftinder
    },
    csc258: {
      csc258,
      breakout
    },
    csc309: {
      csc309,
      oneOnOne
    },
    csc311: {
      csc311,
      graph
    },
    csc396: {
      csc396,
      housinghippos
    },
    csc494: {
      csc494,
      campuseats
    },
    csc491: {
      horologic,
      sentinel
    },
    craftingsjoy: {
      craftingsjoy,
      craftingsjoyBOTA,
      craftingsjoyInsta
    },
    upcyc: {
      upcyc,
      upcycBOTA,
      upcycNCOY,
      upcycPrototype,
      upcycWebsite,
      upcycInsta
    },
    brainer: {
      brainer,
      brainerPromo,
      brainerTeam,
      brainerPrototype,
      brainerWebsite,
      brainerInsta
    },
    battle,
    uniplanit,
    petudier,
    uclit,
    asocial,
    // Alias for components that reference uoftinder directly (e.g. AboutRecentProjects)
    uoftinder: uoftinder,
};

export default srcURLs;
